"use strict";

exports.__esModule = true;
exports.FontPicker = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Translator = require("../../Core/Translator");
var _excluded = ["value", "availableFonts", "onChange", "style"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * A button which shows a font picker in a popover when clicked.
 */
var FontPicker = exports.FontPicker = /*#__PURE__*/function (_Component) {
  function FontPicker() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(FontPicker, _Component);
  var _proto = FontPicker.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      value = _this$props.value,
      availableFonts = _this$props.availableFonts,
      onChange = _this$props.onChange,
      style = _this$props.style,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref) {
      var translate = _ref.translate;
      return /*#__PURE__*/_react["default"].createElement(_core.Popover, {
        minimal: true,
        position: _core.Position.BOTTOM_LEFT,
        content: /*#__PURE__*/_react["default"].createElement(_core.Menu, null, /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
          active: !value,
          onClick: function onClick() {
            return onChange(undefined);
          },
          text: translate("FontPicker.placeholder", "Default Font")
        }), /*#__PURE__*/_react["default"].createElement(_core.MenuDivider, null), availableFonts.map(function (fontFamily) {
          return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
            key: fontFamily,
            active: fontFamily === value,
            onClick: function onClick() {
              return onChange(fontFamily);
            },
            text: /*#__PURE__*/_react["default"].createElement("span", {
              style: {
                fontFamily: fontFamily
              }
            }, fontFamily)
          });
        }))
      }, /*#__PURE__*/_react["default"].createElement(_core.Button, _extends({
        icon: _icons.IconNames.FONT
      }, extra, {
        style: Object.assign({}, style, {
          fontFamily: value,
          lineHeight: 1
        })
      }), value || translate("FontPicker.placeholder", "Default Font")));
    });
  };
  return FontPicker;
}(_react.Component);
FontPicker.defaultProps = {
  availableFonts: ["Arial", "Courier New", "Georgia", "Lucida Sans Unicode", "Tahoma", "Times New Roman", "Trebuchet MS", "Verdana"]
};